import { render, staticRenderFns } from "./index.vue?vue&type=template&id=ddf10330&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=ddf10330&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\webproject\\haoyu\\wms-web\\WMS\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ddf10330')) {
      api.createRecord('ddf10330', component.options)
    } else {
      api.reload('ddf10330', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=ddf10330&", function () {
      api.rerender('ddf10330', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parse/3-32/index.vue"
export default component.exports